import CandidatesInBankOfTalentsEdit from './CandidatesInBankOfTalentsEdit';

export default CandidatesInBankOfTalentsEdit;
